import React, { createContext, useState, useEffect, useContext } from "react";
import de from "../assets/lang/de.json"
import en from "../assets/lang/en.json"
import zh from "../assets/lang/zh.json"

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {

  const [language, setLanguage] = useState(() => {
    const lang = localStorage.getItem("lang") 
      ?? navigator.language?.slice(0, 2) 
      ?? navigator.userLanguage?.slice(0, 2);
  
    return ["de", "en", "zh"].includes(lang) ? lang : "en";
  });


  useEffect(() => {
    localStorage.setItem("lang", language);
  }, [language]);

  

  const translate = (page, key) => {
        if(language === "de" && de[page]){
            return de[page][key] || key
        }else if(language === "en" && en[page]){
            return en[page][key] || key
        }else if(language === "zh" && zh[page]){
          return zh[page][key] || key
        }else{
            return key;
        }
  };

  const ForRegular = ({children}) => {
    if(language !== "zh"){
      return ({...children})
    }
  }

  const ForChina = ({children}) => {
    if(language === "zh"){
      return ({...children})
    }
  }

  return (
    <LanguageContext.Provider value={{setLanguage, translate, ForChina, ForRegular, language }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {return useContext(LanguageContext)}

export const useTranslate = (page) => {
    const {translate} = useContext(LanguageContext)
    return (key) => translate(page, key)
}